import { NavLink, useLocation } from 'react-router-dom';
import {
  BarChart3,
  ArrowLeftRight,
  Tag,
  Users,
  MoreHorizontal,
} from 'lucide-react';
import { useState } from 'react';
import styles from './BottomNav.module.css';

const mainItems = [
  { path: '/report', label: 'Report', icon: BarChart3 },
  { path: '/movimenti', label: 'Movimenti', icon: ArrowLeftRight },
  { path: '/categorie', label: 'Categorie', icon: Tag },
  { path: '/rubrica', label: 'Rubrica', icon: Users },
];

const moreItems = [
  { path: '/scadenze', label: 'Scadenze' },
  { path: '/articoli', label: 'Magazzino' },
  { path: '/risorse', label: 'Risorse' },
  { path: '/categorie-articoli', label: 'Merceologia' },
  { path: '/tipi-pagamento', label: 'Tipi Pagamento' },
  { path: '/tipi-contatto', label: 'Tipi Contatto' },
  { path: '/impostazioni', label: 'Impostazioni' },
];

const BottomNav = () => {
  const location = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);

  const isMoreActive = moreItems.some(
    (item) =>
      location.pathname === item.path ||
      location.pathname.startsWith(item.path + '/')
  );

  return (
    <>
      {moreOpen && (
        <div className={styles.moreOverlay} onClick={() => setMoreOpen(false)}>
          <div
            className={styles.moreMenu}
            onClick={(e) => e.stopPropagation()}
            role="menu"
            aria-label="Menu aggiuntivo"
          >
            {moreItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={`${styles.moreItem} ${
                  location.pathname === item.path ? styles.active : ''
                }`}
                onClick={() => setMoreOpen(false)}
                role="menuitem"
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}

      <nav
        className={styles.bottomNav}
        role="navigation"
        aria-label="Navigazione principale"
      >
        {mainItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path + '/');

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`${styles.navItem} ${isActive ? styles.active : ''}`}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon size={24} aria-hidden="true" />
              <span className={styles.label}>{item.label}</span>
            </NavLink>
          );
        })}

        <button
          className={`${styles.navItem} ${isMoreActive ? styles.active : ''}`}
          onClick={() => setMoreOpen(!moreOpen)}
          aria-expanded={moreOpen}
          aria-haspopup="menu"
          aria-label="Altre opzioni"
        >
          <MoreHorizontal size={24} aria-hidden="true" />
          <span className={styles.label}>Altro</span>
        </button>
      </nav>
    </>
  );
};

export default BottomNav;
